import type { LoaderFunctionArgs, MetaFunction } from '@remix-run/node'
import { Button } from '#app/components/ui/button.js'
import { prisma } from '#app/utils/db.server.ts'
import { json } from '@remix-run/node'
import Logo from '#app/assets/images/phd-logo.png'
import LogoW from '#app/assets/images/phd-logo.webp'
import { useOptionalUser } from '#app/utils/user.ts'
import { Form, Link } from '@remix-run/react'

export async function loader({ request }: LoaderFunctionArgs) {
	const seo = await prisma.sEOSettings.findUnique({
		where: { page: 'HOME' },
	})

	return json({ seo })
}

export default function Index() {
	const user = useOptionalUser()
	return (
		<>
			<div className="bg-phd-pattern-black bg-neutral-900">
				<div className="flex h-screen items-center justify-center">
					<div className="space-y-8 text-center">
						<picture>
							<source srcSet={LogoW} type={'image/webp'} />
							<img
								src={Logo}
								alt="Pharmicated"
								className="px-8 hover:drop-shadow-2xl"
							/>
						</picture>

						{user && (
							<div className="flex justify-center gap-2">
								<Button asChild size="lg" variant="outline">
									<Link to="/dashboard">Dashboard</Link>
								</Button>
								<Form action="/logout" method="POST" className="px-2 pb-2">
									<Button type="submit" size="lg" variant="destructive">
										Logout
									</Button>
								</Form>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* <Footer /> */}
		</>
	)
}
